<template>
  <div>
    <inline-field-actions :schema="schema"></inline-field-actions>
    <div class="opinion-scale">
      <div class="opinion-scale__labels">
        <span>{{ schema.startLabel }}</span>
        <span>{{ schema.endLabel }}</span>
      </div>
      <div class="opinion-scale__range">
        <div class="opinion-scale__value" :class="activeClass(index)" v-for="index in 10" @click="setValue(index)">
          {{ index }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator';
  import { mapMutations } from 'vuex';

  export default {
    mixins: [abstractField],

    methods: {
      ...mapMutations('admin', [
        'setFormChanged',
      ]),

      setValue(value) {
        this.value = value;
        this.setFormChanged(true);
      },

      activeClass(value) {
        if (value === this.value) {
          return 'opinion-scale__value--active';
        }
        return false;
      },
    },
  };
</script>
